import React from "react";
import TSTable from "../common/TSTable";
import { Layout, Tooltip } from 'antd';
import HeaderScreen from "../common/HeaderScreen";
import * as _ from "lodash";
import { Content } from "antd/es/layout/layout";
import { SECONDARY_COLOR, WHITE_COLOR } from "../constants/color";
import { URL_TRUCK } from "../constants/urls";
import { useParams } from "react-router-dom";
import { GET } from "../frameworks/HttpClient";
import { dateToHumanString, getLabResultColor, timeToString, toFixed } from "../frameworks/Util";
import ErrorMessages from "../common/ErrorMessages";
import { LICENSE_PLATE_TYPE } from "../constants/string";

export default function PondTruckHistoryScreen() {
  const params = useParams();
  const [transactionData, setTransactionData] = React.useState(null);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const isSubstitute = params.type === LICENSE_PLATE_TYPE.SUBTITUTE ? true : false
  const tableRef = React.useRef();

  const fetchTransactionData = async() => {
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_TRUCK.TRUCK_TRANSACTION}${params.id}/`)
      setTransactionData(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const columns = [
    {
      title : 'เลขที่บัตร',
      dataIndex : 'code',
    },
    {
      title : 'ผู้ขาย',
      dataIndex : 'supplier_name',
      searcher : true
    },
    {
      title : 'ทะเบียนรถ',
      dataIndex : 'vehicle_license_plate',
      render : (value, original) => {
        if(isSubstitute){
          return _.get(original, 'substitute_license_plate', '')
        } else {
          return value
        }
      }
    },
    {
      title : 'เข้า',
      children: [
        {
          title : "วัน - เวลา",
          dataIndex: "in_datetime",
          render : (value) => {
            return <center>
            <div>{value ? dateToHumanString(value) : '-'}</div>
            <div>{value ? timeToString(value) : '-'}</div>
            </center>
          }
        },
        {
          title : "น้ำหนัก",
          dataIndex: "in_weight",
          render : (value) => {
            return <center>{value ? value : '-'}</center>
          }
        }
      ]
    },
    {
      title : 'ออก',
      children: [
        {
          title : "วัน - เวลา",
          dataIndex: "out_datetime",
          render : (value) => {
            return <center>
            <div>{value ? dateToHumanString(value) : '-'}</div>
            <div>{value ? timeToString(value) : '-'}</div>
            </center>
          }
        },
        {
          title : "น้ำหนัก",
          dataIndex: "out_weight",
          render : (value) => {
            return <center>{value ? value : '-'}</center>
          }
        }
      ]
    },
    {
      title : 'น้ำหนักสุทธิ',
      dataIndex : 'net_weight',
      render : (value) => {
        return <center>{value ? value : '-'}</center>
      }
    },
    {
      title : 'Lot น้ำยางสด',
      dataIndex : '',
      render : (value, original) => original.pond_input ?
      <>
      <div>ล็อต : {_.get(original, "lot_no_input", "-")}</div>
      <div>บ่อ : {_.get(original, 'pond_input', '-')}</div>
      <div>กระบะ : {_.get(original, 'tray_input', '-')}</div>
      </> : '-'
    },
    {
      title: "ผลแล็บ",
      dataIndex: "",
      key: "lab_results",
      render: (value, original) => {
        return _.get(original, "lab_results", "-").map((item) => {
          return (
            <div style={{ color: getLabResultColor(_.get(item, 'status', null)) }}>
              <Tooltip title={item.note}>{item.chemical} : {toFixed(item.amount, 3)}</Tooltip>
            </div>
          );
        });
      },
    },
  ]

  const handleClose = () => {
    window.close();
  };

  React.useEffect(() => {
    fetchTransactionData();
  },[])

  React.useEffect(() => {
    if(transactionData){
      refreshData();
    }
  },[transactionData])

	return(
    <Layout>
      <HeaderScreen 
        title={`ประวัติการรับยาง${isSubstitute ? 
          ` - [${_.get(transactionData, 'substitute_license_plate', '')}]` : 
          ` - [${_.get(transactionData, 'vehicle_license_plate', '')}]`}`} 
        style={{ backgroundColor : SECONDARY_COLOR, 
        color : WHITE_COLOR, fontSize : 18, fontWeight: 'bolder' }} 
        onClick={handleClose}
      />
      <Content
        style={{
          margin: 24,
          minHeight: 280,
          padding: "0px 24px",
      }}>
        <ErrorMessages message={errorMessages}/>
        <TSTable
          ref={tableRef}
          columns={columns}
          url={_.get(transactionData, 'vehicle_license_plate', false) ? URL_TRUCK.TRUCK_TRANSACTION : ''}
          size={"small"}
          params={
            isSubstitute ? 
            {substitute_license_plate : _.get(transactionData, 'substitute_license_plate', '')} :
            {vehicle_license_plate : _.get(transactionData, 'vehicle_license_plate', '')}
          }
        />
      </Content>
    </Layout>
)
}